/**
 * @功能名称: on方法实现
 * @文件名称: domEvent.js
 * Events 结构用于存放事件 handle
 * guid 用于对应 绑定事件的dom和 handle 的对应关系
 * Events: [
 *      {
 *      0:{ },//自身绑定
 *      select1:{
 *        click:[handle...],
 *        ...
 *      }
 *      select2:...
 *    }
 *    ...
 * ]
 *
 * @Date: 2018/8/4 下午3:52.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 */


import {realType} from './utils';

class init {
  constructor(selector) {
    this.length = 0;
    if (!selector) {
      return this;
    }
    if (typeof selector === 'string') {
      this.push(...document.querySelectorAll(selector));
      return this;
    }
    if (realType(selector) === 'nodelist') {
      this.push(...selector);
      return this;
    } else if (typeof selector === 'object') {
      this.push(selector);
      return this;
    } else if (typeof selector == 'function') {
      $.ready(selector);
      return;
    }
  }
  push() {
    return [].push.apply(this, arguments);
  }

  forEach() {
    return [].forEach.apply(this, arguments);
  }

  map() {
    return [].map.apply(this, arguments);
  }
  on(type, selector, fn) {
    if (typeof selector === 'function') {
      fn = selector;
      selector = 0;
    }
    this.forEach(dom => {
      var id = dom.guid,
        handlers = $.Events[id];

      if (id >= 0) {
        if (!handlers[selector]) {
          handlers[selector] = {};
          handlers[selector][type] = [fn];
          init.add(dom, type, selector);
        } else {
          if (handlers[selector][type]) {
            handlers[selector][type].push(fn);
          } else {
            handlers[selector][type] = [fn];
            init.add(dom, type, selector);
          }
        }
      } else {
        dom.guid = ++$.guid;
        $.Events[$.guid] = {};
        $.Events[$.guid][selector] = {};
        $.Events[$.guid][selector][type] = [fn];
        init.add(dom, type, selector);
      }
    });
    return this;
  }

  data(attr, val) {
    return this.map((dom, i) => {
      if (arguments.length == 1) {
        return dom.getAttribute('data-' + attr);
      } else {
        dom.setAttribute('data-' + attr, val);
        return dom;
      }
    });
  }

  static filiter(dom, selector, target) {
    var nodes = dom.querySelectorAll(selector);
    return [].some.call(nodes, item => {
      return item === target;
    });
  }

  static add(dom, type, selector) {
    dom.addEventListener(type, function(e) {
      var id = dom.guid;
      var arrFn = $.Events[id][selector][type];
      var prevent = false;
      if (selector) {
        var target = e.target;
        var currentTarget = e.currentTarget;
        while (!prevent && target && target != currentTarget) {
          if (init.filiter(dom, selector, target)) {
            arrFn.forEach(fn => {
              var re = fn.call(target, e);
              if (re === false) {
                prevent = true;
              }
            });
          }
          target = target.parentNode;
        }
      } else {
        prevent = arrFn.some(fn => {
          return fn.call(dom, e) === false;
        });
      }
      if (prevent) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
}

function $(selector) {
  return new init(selector);
}
$.ready = function(fn) {
  document.addEventListener('DOMContentLoaded', fn);
}
$.Events = [];
$.guid = -1;

export default $
